<div class="animated container-fluid container-filter mt-n1">
    <form [formGroup]="form" class="needs-validation" novalidate>
        <div class="animated fadeIn">    
            <div class="row">
                <div class="col-md-12">
                    <h3>Búsqueda de {{ title.plural }} para {{ editMode ? 'añadir a' : 'crear' }} la Unidad de Inspección</h3>
                </div>
            </div>
            <div *ngIf="!editMode" class="row ps-2">
                <ng-container *ngIf="!tamanioMaximoAgrupacion">
                    <div class="col-6 nota-info mt-2 mb-1" role="alert">
                        <label class="col-form-label"><i class="fa fa-info-circle" aria-hidden="true"></i> Superficie máxima de agrupación (ha): Sin límite</label>
                    </div>
                </ng-container>
                <ng-container *ngIf="EANoHabilitada && (isOperadorCam || isCA)">
                    <div class="col-6 nota-info mt-2 mb-1" role="alert">
                        <label class="col-form-label"><i class="fa fa-info-circle" aria-hidden="true"></i> La C.A. seleccionada no está habilitada para filtrar por Entidad Auditora</label>
                    </div>
                </ng-container>
            </div>
    
            <div class="row">
                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
                            aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-filter"></i> Criterios de búsqueda
                                <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>
                        <div class="card-body">
    
                            <div class="collapse group-filtros" id="collapse" [ngbCollapse]="isCollapsed">
    
                                <!-- Con editMode controlamos si mostrar o no los inputs que permiten realizar la búsqueda en modo creación.
                                En modo edición, ya no es necesario buscar por éstos inputs principales, así que los ocultamos.
                                -->
                                <div *ngIf="!editMode" class="row">
    
                                    <div class="form-group col-xl-3 col-md-3 col-sm-6">
                                        <label class="col-form-label required-field" for="IdCampania">Campaña</label>
                                        <ng-select appendTo="body"
                                            loadingText="Cargando..."
                                            [items]="campanias"
                                            [readonly]="!campanias || campanias.length === 0"
                                            bindLabel="Descripcion"
                                            bindValue="Id"
                                            formControlName="IdCampania"
                                            [loading]="campanias === null"
                                            placeholder="-- Seleccione una Campaña --"
                                            [ngClass]="displayFieldCssNgSelect('IdCampania')"
                                            (change)="onSelectCampania($event?.Id)"
                                            notFoundText="Campaña no encontrada"
                                            clearAllText="Eliminar selección">
                                            <ng-template ng-option-tmp let-item="item">
                                                <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                            </ng-template>
                                        </ng-select>
                                        <div id="validationCampaniaFeedback" class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdCampania','required')">
                                            Campaña es obligatoria
                                        </div>
                                    </div>
    
                                    <div class="form-group col-xl-3 col-md-3 col-sm-6">
                                        <label class="col-form-label required-field" for="IdPeriodo">Periodo</label>
                                        <ng-select appendTo="body"
                                            loadingText="Cargando..."
                                            [items]="periodos"
                                            [readonly]="!periodos || periodos.length === 0"
                                            bindLabel="DescripcionPeriodo"
                                            bindValue="Id"
                                            formControlName="IdPeriodo"
                                            [loading]="periodos === null && form.value.IdCampania !== null"
                                            placeholder="-- Seleccione un Periodo --"
                                            [ngClass]="displayFieldCssNgSelect('IdPeriodo')"
                                            (change)="onSelectPeriodo($event?.Id)"
                                            notFoundText="Periodo no encontrado"
                                            clearAllText="Eliminar selección">
                                            <ng-template ng-option-tmp let-item="item">
                                                <div container="body" ngbTooltip="{{ item.DescripcionPeriodo }}">{{ item.DescripcionPeriodo }}</div>
                                            </ng-template>
                                        </ng-select>
                                        <div class="invalid-feedback tip d-block">
                                            <label>(Depende de la "Campaña")</label>
                                        </div>
                                        <div id="validationPeriodoFeedback" class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPeriodo','required')">
                                            Periodo es obligatorio
                                        </div>
                                    </div>
    
                                    <div *ngIf="!isCA" class="form-group col-xl-2 col-md-3 col-sm-6">
                                        <label class="col-form-label required-field" for="IdCA">Com. Autónoma</label>
                                        <ng-select appendTo="body"
                                            loadingText="Cargando..."
                                            [items]="CAs"
                                            [readonly]="!CAs || CAs.length === 0"
                                            placeholder="-- Seleccione una C.A. --"
                                            [loading]="CAs === null"
                                            bindLabel="ComunidadAutonoma"
                                            bindValue="IdCa"
                                            formControlName="IdCA"
                                            [ngClass]="displayFieldCssNgSelect('IdCA')"
                                            (change)="onSelectComunidadAutonoma($event)"
                                            notFoundText="C.A. no encontrada"
                                            clearAllText="Eliminar selección">
                                            <ng-template ng-option-tmp let-item="item">
                                                <div container="body" ngbTooltip="{{ item.ComunidadAutonoma }}">{{ item.ComunidadAutonoma }}</div>
                                            </ng-template>
                                        </ng-select>
                                        <div class="invalid-feedback tip d-block">
                                            <label>(Todas o del "Periodo")</label>
                                        </div>
                                        <div id="validationCAFeedback" class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdCA','required')">
                                            Comunidad Autónoma es obligatoria
                                        </div>
                                    </div>
    
                                    <div *ngIf="!isEA" class="form-group col-xl-2 col-md-3 col-sm-6">
                                        <label class="col-form-label" [ngClass]="{ 'required-field': entidadAuditoraEnabledForCA }" for="IdEntidadAuditora">Entidad Auditora</label>
                                        <ng-select appendTo="body"
                                            loadingText="Cargando..."
                                            [items]="EAs"
                                            [readonly]="!EAs || EAs.length === 0 || form.value.IdCA === null || !entidadAuditoraEnabledForCA"
                                            placeholder="-- Seleccione una E.A. --"
                                            [loading]="(EAs === null && (form.value.IdCA !== null) && entidadAuditoraEnabledForCA)"
                                            bindLabel="Descripcion"
                                            bindValue="Id"
                                            formControlName="IdEntidadAuditora"
                                            [ngClass]="displayFieldCssNgSelect('IdEntidadAuditora')"
                                            (change)="onSelectEntidadAuditora($event)"
                                            notFoundText="E.A. no encontrada"
                                            clearAllText="Eliminar selección">
                                            <ng-template ng-option-tmp let-item="item">
                                                <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                            </ng-template>
                                        </ng-select>
                                        <div class="invalid-feedback tip d-block">
                                            <label>(depende de "Periodo" y "C.A.")</label>
                                        </div>
                                        <div id="validationEAFeedback" class="invalid-feedback d-block" *ngIf="entidadAuditoraEnabledForCA && isFieldInvalid('IdEntidadAuditora','required', true)">
                                            Entidad Auditora es obligatoria
                                        </div>                         
                                    </div>
                                    
                                    <div class="form-group col-xl-2 col-md-3 col-sm-6">
                                        <label class="col-form-label required-field" for="IdTipoSolicitudCam">Tipo de Solicitud</label>
                                        <ng-select appendTo="body"
                                            loadingText="Cargando..."
                                            [items]="tiposSolicitud"
                                            [readonly]="!tiposSolicitud || tiposSolicitud.length === 0 || form.value.IdPeriodo === null"
                                            placeholder="-- Seleccione un Tipo de Solicitud --"
                                            [loading]="tiposSolicitud === null"
                                            bindLabel="Descripcion"
                                            bindValue="Id"
                                            formControlName="IdTipoSolicitudCam"
                                            [ngClass]="displayFieldCssNgSelect('IdTipoSolicitudCam')"
                                            (change)="onSelectTipoSolicitud($event)"
                                            notFoundText="Tipo de Recinto no encontrado"
                                            clearAllText="Eliminar selección">
                                            <ng-template ng-option-tmp let-item="item">
                                                <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                            </ng-template>
                                        </ng-select>
                                        <div class="invalid-feedback tip d-block">
                                            <label ngbTooltip="PIAEd = Parcela-Invernadero-Almacén-Empresa Deshidratadora">(o Recinto "PIAEd")</label>
                                        </div>
                                        <div id="validationTipoFeedback" class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdTipoSolicitudCam','required')">
                                            Tipo de Solicitud es obligatorio
                                        </div>
                                    </div>

                                    <div *ngIf="!isOperadorCam" class="form-group col-xl-2 col-md-3 col-sm-6">
                                        <label class="col-form-label required-field" for="IdOperador">Operador</label>
                                        <ng-select appendTo="body"
                                            loadingText="Cargando..."
                                            [items]="operadores"
                                            [readonly]="!operadores || operadores?.length === 0 || form.value.IdTipoSolicitudCam === null"
                                            placeholder="-- Seleccione un Operador --"
                                            [loading]="operadores === null"
                                            bindLabel="Descripcion"
                                            bindValue="Id"
                                            formControlName="IdOperador"
                                            [ngClass]="displayFieldCssNgSelect('IdOperador')"
                                            notFoundText="Operador no encontrado"
                                            clearAllText="Eliminar selección">
                                            <ng-template ng-option-tmp let-item="item">
                                                <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                            </ng-template>
                                        </ng-select>
                                        <div id="validationOperadorFeedback" class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdOperador','required')">
                                            Operador es obligatorio
                                        </div>
                                        <div *ngIf="operadores?.length === 0" class="invalid-feedback d-block">
                                            No se han encontrado Operadores
                                        </div>
                                    </div>
                                             
                                </div>
                                <div class="row">
    
                                    <div class="form-group col-xl-2 col-lg-3 col-md-3 col-sm-6">
                                        <label class="col-form-label" for="FechaDesdePresentacion">Desde</label> <label class="small">(Fecha de presentación)</label>
                                        <p-calendar appendTo="body" formControlName="FechaDesdePresentacion" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                    </div>
    
                                    <div class="form-group col-xl-2 col-lg-3 col-md-3 col-sm-6">
                                        <label class="col-form-label" for="FechaHastaPresentacion">Hasta</label> <label class="small">(Fecha de Presentación)</label>
                                        <p-calendar appendTo="body" formControlName="FechaHastaPresentacion" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                    </div>                                
    
                                    <div class="form-group col-xl-2 col-lg-3 col-md-3 col-sm-6">
                                        <label class="col-form-label" for="IdProvincia">Provincia</label>
                                        <ng-select appendTo="body"
                                            loadingText="Cargando..."
                                            [items]="provincias"
                                            [readonly]="!provincias || provincias.length === 0"
                                            placeholder="-- Seleccione una Provincia --"
                                            [loading]="provincias === null" 
                                            bindLabel="Descripcion"
                                            bindValue="Id"
                                            formControlName="IdProvincia"
                                            [ngClass]="displayFieldCssNgSelect('IdProvincia')"
                                            (change)="onSelectProvincia($event)"
                                            notFoundText="Provincia no encontrada"
                                            clearAllText="Eliminar selección">
                                            <ng-template ng-option-tmp let-item="item">
                                                <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                            </ng-template>
                                        </ng-select>
                                    </div>
    
                                    <div class="form-group col-xl-2 col-lg-3 col-md-3 col-sm-6">
                                        <label class="col-form-label" for="IdMunicipio">Municipio</label>
                                        <ng-select appendTo="body"
                                            loadingText="Cargando..."
                                            [items]="municipios"
                                            [readonly]="!municipios || form.value.IdProvincia === null"
                                            placeholder="-- Seleccione un Municipio --"
                                            [loading]="!municipios && form.value.IdProvincia !== null" 
                                            bindLabel="Descripcion"
                                            bindValue="Id"
                                            formControlName="IdMunicipio"
                                            [ngClass]="displayFieldCssNgSelect('IdMunicipio')"
                                            notFoundText="Municipio no encontrado"
                                            clearAllText="Eliminar selección">
                                            <ng-template ng-option-tmp let-item="item">
                                                <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                            </ng-template>
                                        </ng-select>
                                    </div>

                                    <!-- Se dejan comentados por si se necesitaran en un futuro -->
                                    <!--
                                    <div class="form-group col-xl-1 col-lg-3 col-md-3 col-sm-2">
                                        <label class="col-form-label" for="agregado">Agregado</label>
                                        <input formControlName="Agregado" name="agregado" maxlength="5"
                                            class="form-control" id="agregado" type="text" value="">
                                    </div>
                                    
                                    <div class="form-group col-xl-1 col-lg-3 col-md-3 col-sm-2">
                                        <label class="col-form-label" for="zona">Zona</label>
                                        <input formControlName="Zona" name="zona" maxlength="5"
                                            class="form-control" id="zona" type="text" value="">
                                    </div>
                                    -->

                                    <div class="form-group col-xl-1 col-lg-3 col-md-3 col-sm-2">
                                        <label class="col-form-label" for="poligono">Polígono</label>
                                        <input formControlName="Poligono" name="poligono" maxlength="5"
                                            class="form-control" id="poligono" type="text" value="">
                                    </div>
    
                                    <div class="form-group col-xl-1 col-lg-3 col-md-3 col-sm-2">
                                        <label class="col-form-label" for="parcela">Parcela</label>
                                        <input formControlName="Parcela" name="parcela" maxlength="10"
                                            class="form-control" id="parcela" type="text" value="">
                                    </div>
    
                                    <div class="form-group col-xl-1 col-lg-3 col-md-3 col-sm-2">
                                        <label class="col-form-label" for="recinto">Recinto</label>
                                        <input formControlName="Recinto" name="recinto" maxlength="10"
                                            class="form-control" id="recinto" type="text" value="">
                                    </div>
                                </div>
                            </div>
    
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group-0 float-right">
    
                                        <div class="btn-group">
                                            <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit"
                                                [disabled]="disableSearchBtn" title="Realiza una búsqueda" (click)="onSearch($event)">
                                                    <i class="fa fa-search"></i> Buscar</button>
                                        </div>
    
                                        <div class="btn-group">
                                            <button class="btn btn-secondary btn-sm" type="button" [disabled]="formIsUntouched"
                                                title="Limpia los filtros" (click)="resetForm($event)">
                                                    <i class="fa fa-eraser"></i> Limpiar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>